import { useTranslation } from 'react-i18next';
import { type GroupItem } from '@scmlatam/web-ui';

import SidebarTimekeeperIcon from '../../assets/icons/sidebar-control-de-tiempo-icon.svg';
import SidebarReportsIcon from '../../assets/icons/sidebar-reporteria-icon.svg';
import { useAuthorization } from '../../contexts/AuthorizationContext';

const useSideBar = () => {
    const { t } = useTranslation('core.sidebar');
    const { canView } = useAuthorization();

    const timekeeperSubgroups = [
        {
            title: t('modules.timekeeper.submodules.workers'),
            path: '&view=workers',
        },
        {
            title: t('modules.timekeeper.submodules.timecard'),
            path: '&view=timecard',
        },
        {
            title: t('modules.timekeeper.submodules.schedule'),
            path: '&view=schedule',
        },
    ].filter((subgroup) => canView(`/timekeeper?${subgroup.path.replace('&', '')}`));

    const reportSubgroups = [
        {
            title: t('modules.reports.submodules.execute_report'),
            path: '&view=results_report',
        },
    ].filter((subgroup) => canView(`/reports?${subgroup.path.replace('&', '')}`));

    const items: GroupItem[] = [
        {
            name: undefined,
            items: [
                {
                    title: t('modules.timekeeper.title'),
                    color: '#f5bb32',
                    icon: <img src={SidebarTimekeeperIcon} alt="sidebar-control-de-tiempo-icon" />,
                    path: '/timekeeper?module=timekeeper',
                    view: 'workers',
                    subgroups: timekeeperSubgroups,
                },
            ],
        },
        {
            name: undefined,
            items: [
                {
                    title: t('modules.reports.title'),
                    color: '#c3d237',
                    icon: <img src={SidebarReportsIcon} alt="sidebar-reportes-icon" />,
                    path: '/reports?module=reports',
                    view: 'results_report',
                    subgroups: reportSubgroups,
                },
            ],
        },
    ];

    const filteredItems = items
        .map((group) => ({
            ...group,
            items: group.items.filter((item: { subgroups?: unknown[] }) => item.subgroups?.length),
        }))
        .filter((group) => group.items.length > 0);

    const tooltips = {
        collapseMenu: t('tooltips.collapseMenu'),
        expandMenu: t('tooltips.expandMenu'),
        collapseModule: t('tooltips.collapseModule'),
        expandModule: t('tooltips.expandModule'),
        openNewTab: t('tooltips.openNewTab'),
    };

    return {
        items: filteredItems,
        tooltips,
    };
};

export { useSideBar };
